import { render, staticRenderFns } from "./recordImage.vue?vue&type=template&id=807842fc&scoped=true"
import script from "./recordImage.vue?vue&type=script&lang=js"
export * from "./recordImage.vue?vue&type=script&lang=js"
import style0 from "./recordImage.vue?vue&type=style&index=0&id=807842fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807842fc",
  null
  
)

export default component.exports